/* eslint-env browser, jquery */
/* globals CountdownTimer */

'use strict';

require('../../groupon-deal-timer/frontend/standard');

const StickyHandler = require('../../sticky_handler/frontend');
const bindTargetNavigation = require('../../deal/responsive/frontend/bind_target_navigation');

const ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;
const PRIMARY_MESSAGE_TIMEOUT_TOUCH = 3000;

const DealHighlights = {
  fixWidthData: {},

  fixWidth(timerData, isSticky = false) {
    if (timerData.isTouchRequest) {
      const MAX_TIMESTAMP_WIDTH = isSticky ? 57 : 62;

      // get current widths
      const containerWidth = document.querySelector(
        '.deal-highlights .columns .text'
      ).offsetWidth;
      const textWidth = document.querySelector(
        '.deal-highlights .columns .text .countdown-text'
      ).offsetWidth;

      const $timestamp = document.querySelector(
        '.deal-highlights .columns .text .countdown-timestamp'
      );
      const $timer = document.querySelector(
        '.deal-highlights .columns .text .countdown-timer'
      );

      const hasDays = timerData.timeLeft.days > 0;
      if (hasDays) {
        $timer.classList.add('with-days');
      }

      if (!this.fixWidthData.daysWidth) {
        const timerWidth = $timer.offsetWidth;
        const timestampWidth = $timestamp.offsetWidth;
        this.fixWidthData.daysWidth = timerWidth - timestampWidth;
      }

      const availableSpace = containerWidth - textWidth;
      const neededSpace = hasDays
        ? MAX_TIMESTAMP_WIDTH + this.fixWidthData.daysWidth
        : MAX_TIMESTAMP_WIDTH;

      const fixingClass = [];
      if (availableSpace < neededSpace) {
        fixingClass.push('two-lines');
      }

      if (
        hasDays &&
        (containerWidth < neededSpace ||
          $timestamp.offsetHeight + 2 < $timer.offsetHeight)
      ) {
        fixingClass.push('three-lines');
      }

      $timer.classList.remove('two-lines', 'three-lines');
      $timer.classList.add(...fixingClass);
    }
  },

  rotateMessages(messagesContainer, loopMessages = false) {
    let currentMessage = messagesContainer.querySelector('.primary');
    let nextMessage = messagesContainer.querySelector('.secondary');

    const switchMessage = () => {
      currentMessage.classList.add('fade-out');
      currentMessage.classList.remove('fade-in');

      nextMessage.classList.add('fade-in');
      nextMessage.classList.remove('fade-out');

      if (loopMessages) {
        const ref = currentMessage;
        currentMessage = nextMessage;
        nextMessage = ref;
      }
    };

    if (loopMessages) {
      return window.setInterval(
        switchMessage,
        PRIMARY_MESSAGE_TIMEOUT_TOUCH + ACTIVATE_PRIMARY_MESSAGE_TIMEOUT
      );
    }
    return window.setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH);
  },

  init({ dealHighlights }, done) {
    if (!dealHighlights) {
      return;
    }

    const { tiles } = dealHighlights;

    const activateRotatingMessaging = ($elements, loopMessages) => {
      $elements.forEach($element => {
        if ($element.getAttribute('data-activated') === 'true') {
          return;
        }
        $element.setAttribute('data-activated', 'true');
        this.rotateMessages($element, loopMessages);
      });
    };

    const scrollHandler = function ($element, loopMessages) {
      const internalScrollHandler = function () {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
          window.removeEventListener('scroll', internalScrollHandler);
          activateRotatingMessaging($element, loopMessages);
        }
      };

      return internalScrollHandler;
    };

    const bindHighlightLinksNavigation = function bindHighlightLinksNavigation(
      id
    ) {
      const $anchorElement = document.querySelector(
        `.deal-highlights a[href="#${id}"]`
      );

      bindTargetNavigation($anchorElement);
    };

    const prepareWindowHandlers = function prepareWindowHandlers(
      $element,
      timeout = ACTIVATE_PRIMARY_MESSAGE_TIMEOUT,
      loopMessages
    ) {
      window.setTimeout(
        () => activateRotatingMessaging($element, loopMessages),
        timeout
      );

      return window.addEventListener(
        'scroll',
        scrollHandler($element, loopMessages)
      );
    };

    let timerData;
    for (let i = 0; i < tiles.length; i += 1) {
      const tile = tiles[i];
      if (tile.secondaryMessage || tile.rotatingMessages) {
        const messageTimer = tile.messageTimerInSec * 1000;
        prepareWindowHandlers(
          document.querySelectorAll(
            '.t-main-inner .deal-highlights, #purchase-cluster .deal-highlights, .multi-option-overlay-cluster .deal-highlights'
          ),
          messageTimer,
          true
        );

        if (
          document.querySelectorAll('#options-pane .deal-highlights').length
        ) {
          window.UrlHashChange.eventPipe.on('showHideOptions', () =>
            prepareWindowHandlers(
              document.querySelectorAll('#options-pane .deal-highlights'),
              ACTIVATE_PRIMARY_MESSAGE_TIMEOUT,
              true
            )
          );
        }
      } else if (tile.jsTimerData) {
        timerData = {
          ...tile.jsTimerData,
          el: '.deal-highlights .countdown-timer',
          translationScope: 'js.modules.groupon-deal-timer.tile',
        };

        CountdownTimer.init({ timerData });
        this.fixWidth(timerData);
      }
    }

    bindHighlightLinksNavigation('tips');

    if (dealHighlights.tilesMeta && dealHighlights.tilesMeta.isStickyUMS) {
      const options = {
        // changed $element and $wrapper to js cuz' jQuery was removed from sticky_handler
        $element: document.querySelector(
          '#global-container .deal-highlights.sticky-ums'
        ),
        $wrapper: document.querySelector(
          '#global-container .deal-highlights-wrapper'
        ),
      };

      if (timerData !== undefined) {
        options.onStateChange = () => {
          document
            .querySelector('#global-container .deal-highlights.sticky-ums')
            .addEventListener(
              'transitionend',
              this.fixWidth.bind(this, timerData, true),
              {
                once: true,
              }
            );
        };
      }

      this.stickyHandler = new StickyHandler(options);
    }
    done();
  },
};

module.exports = DealHighlights;
